import base from "../../baseurl";
import token from "../../getTk";

const Create = async (title, img, body, url, sportEventId) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const newS = await api
    .post("indets/create", {
      json: { title, img, body, url, sportEventId },
      timeout: false,
    })
    .json();
  return newS;
};

export default Create;
